export type SubmissionLifecycleState = 'idle' | 'pending' | 'success' | 'error';

export type SubmissionStatusRecord = {
  submissionId?: string | null;
  status?: string | null;
  deadLettered?: boolean | null;
  errorCode?: string | null;
  errorMessage?: string | null;
};

export type SubmissionPollResolution = {
  nextState: SubmissionLifecycleState;
  shouldContinuePolling: boolean;
};

const TRANSIENT_STATUS = {
  QUEUED: 'queued',
  PROCESSING: 'processing',
} as const;

const TERMINAL_STATUS = {
  SUCCEEDED: 'succeeded',
  REJECTED: 'rejected',
  ERROR: 'error',
} as const;

export const isAcceptedAsyncSubmissionStatus = (status?: string | null): boolean =>
  status === TRANSIENT_STATUS.QUEUED || status === TRANSIENT_STATUS.PROCESSING;

export const resolveSubmissionPollingState = (
  statusRecord?: SubmissionStatusRecord
): SubmissionPollResolution => {
  const status = statusRecord?.status ?? null;
  const deadLettered = statusRecord?.deadLettered ?? false;

  if (
    isAcceptedAsyncSubmissionStatus(status) ||
    (status === TERMINAL_STATUS.ERROR && !deadLettered)
  ) {
    return { nextState: 'pending', shouldContinuePolling: true };
  }

  if (status === TERMINAL_STATUS.SUCCEEDED) {
    return { nextState: 'success', shouldContinuePolling: false };
  }

  if (status === TERMINAL_STATUS.REJECTED || (status === TERMINAL_STATUS.ERROR && deadLettered)) {
    return { nextState: 'error', shouldContinuePolling: false };
  }

  return { nextState: 'idle', shouldContinuePolling: false };
};
